import { NgModule } from '@angular/core';
import { LayoutModule } from '../../layout/layout.module';
import { ComponentsModule } from '../../components/components.module';
import { CadastrarFornecedorComponent } from './cadastrar-fornecedor/cadastrar-fornecedor.component';
import { PedidoMaterialComponent } from './pedido-material/pedido-material.component';
import { FornecedoresComponent } from './fornecedores/fornecedores.component';
import { SuprimentosRoutingModule } from './suprimentos-routing.module';
import { PedidosComponent } from './pedidos/pedidos.component';

@NgModule({
  declarations: [
    PedidosComponent,
    PedidoMaterialComponent,
    FornecedoresComponent,
    CadastrarFornecedorComponent,
  ],
  imports: [SuprimentosRoutingModule, ComponentsModule, LayoutModule],
  exports: [],
})
export class SuprimentosModule {}
